module.exports = __webpack_public_path__ + "img/numerology_cover.7215aeb3.png";